export const FETCH_INITIAL_TEMPLATES_DATA_REQUEST = "FETCH_INITIAL_TEMPLATES_DATA_REQUEST";
export const FETCH_INITIAL_TEMPLATES_DATA_SUCCESS = "FETCH_INITIAL_TEMPLATES_DATA_SUCCESS";
export const FETCH_INITIAL_TEMPLATES_DATA_FAILURE = "FETCH_INITIAL_TEMPLATES_DATA_FAILURE";
